/* eslint-disable @typescript-eslint/no-explicit-any */
import { Navigate, Route, Routes } from 'react-router-dom'

import { constants, links, paths } from 'apps'
import { useAppSelector, useLocalStorage } from 'hooks'
import { CommonLayout } from 'layouts'
import { useEffect } from 'react'
import { PrivateRoute } from 'routes'
import { TopHorses, TopUsers, RankingMain } from './pages'
import TopRecordRanking from './pages/TopRecordRanking'
import { STRING_REGION } from 'apps/constants'
import { useAvailableWallet } from 'features/Auth/pages/Main/useAvailableWallet'

const tabs = [
  {
    name: 'Top Horses',
    link: links.ranking.topHorses()
  },
  {
    name: 'Top Users',
    link: links.ranking.topUsers()
  }
]

const tabsRecord = [
  {
    name: 'JAPAN',
    link: links.ranking.topRecordJapan()
  },
  {
    name: 'KOREA',
    link: links.ranking.topRecordKorea()
  }
]

function SpecialRace() {
  const [, setUserId] = useLocalStorage(constants.USER_ID_KEY, 0)
  const [, setAccessToken] = useLocalStorage(constants.ACCESS_TOKEN_KEY, null)
  const [, setRefreshToken] = useLocalStorage(constants.REFRESH_TOKEN_KEY, null)
  const auth = useAppSelector(state => state.auth)
  const providers = useAvailableWallet()
  const storedWalletName = localStorage.getItem('walletName')

  useEffect(() => {
    if (providers.length && storedWalletName) {
      const checkSignerProfile = async () => {
        const matchedProviderDetail = providers.find(
          (p) => p.info.name === storedWalletName
        )
        const ethereumProvider = matchedProviderDetail?.provider as any
        if (!ethereumProvider ) {
          setUserId(0)
          setAccessToken('')
          setRefreshToken('')
        }
      }
      checkSignerProfile()
    }
  }, [providers, storedWalletName])

  return (
    <Routes>
      <Route
        path={paths.default()}
        element={
          <PrivateRoute isLogged={auth.isLogged} layout={CommonLayout} navigate={links.home.index()}>
            <RankingMain titleTabs={tabs} />
          </PrivateRoute>
        }
      >
        <Route path={paths.ranking.topHorses()} element={<TopHorses />} />
        <Route path={paths.ranking.topUsers()} element={<TopUsers />} />
      </Route>
      <Route
        path={paths.default()}
        element={
          <PrivateRoute isLogged={auth.isLogged} layout={CommonLayout} navigate={links.home.index()}>
            <RankingMain titleTabs={tabsRecord} />
          </PrivateRoute>
        }
      >
        <Route path={paths.ranking.topRecordJapan()} element={<TopRecordRanking region={STRING_REGION.TOKYO} />} />
        <Route path={paths.ranking.topRecordKorea()} element={<TopRecordRanking region={STRING_REGION.SEOUL} />} />
      </Route>
      <Route path='*' element={<Navigate replace to={paths.notFound.feature()} />} />
    </Routes>
  )
}


export default SpecialRace
